import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import VueHeadful from 'vue-headful';

import { globalFormatDate } from '../public/utils.js';

Vue.use(VueRouter)

Vue.component('vue-headful', VueHeadful);

Vue.config.productionTip = false

const routes = [
  { path: '*', component: App }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

Vue.mixin({
  data: function () {
    return {
      nodePort: 4000,
      nbsp: '&nbsp;',
      site_title: 'RPG Planet Board (в прошлом Realms.ru)',
      publicPath: process.env.BASE_URL,
    }
  },
  methods: {
    getNodePath() {
      //console.log(this.$router.history.current.fullPath); // will output /index.php?act=Members
      return window.location.protocol + "//" + window.location.hostname + ":" + this.nodePort + "/"
    },
    htmlDecode(input) {
      let doc = new DOMParser().parseFromString(input, "text/html");
      return doc.documentElement.textContent;
    },
    spanSeconds(dateEarly, dateLater) {
      let delta = Math.abs(dateLater - dateEarly) / 1000;
      return delta;
    },
    fixAvatarPath(path) {
      if (!path || path.length == 0 || path.startsWith("http://"))
        return path;
      return this.publicPath + 'avatars/' + path;
    }
  },
  filters: {
    formatDate: function(value) {
      return globalFormatDate(value);
    },
    formatInt: function(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "); // formats 4123 to 4 123
    }
  }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
